<template>

    <div class="select-wrapper" :class="{ active : isToggled, wprce : price }" @click.prevent="toggleItem">
        <div class="bg"></div>
        <div class="content">
            <div class="chckr">
                <div class="ibg"></div>
                <span class="ico">
                    <svg width="16" height="12" viewBox="0 0 21 16" fill="none">
                        <path d="M3 7.5L8.5 13L18.5 3" stroke="#191818" stroke-width="3" stroke-linecap="square"/>
                    </svg>
                </span>
            </div>
            <div class="inner-content">
                <span class="ft-xbld item">{{ item }}</span>
                <p class="caption" v-if="caption">{{ caption }}</p>
                <span class="ft-bld billed txt-main" v-if="billedPrice">{{ billedPrice }}</span>
            </div>
            <div class="price-cap ft-xbld" v-if="price">
                <span class="big txt-grt">{{ price }}€</span>
                <span class="sml txt-grt">/month</span>
            </div>
        </div>
    </div>

</template>

<script>

    export default {

        name: 'SelectWrapper',

        props: {
            value: {
                type: Boolean,
                default: false
            },
            item: String,
            caption: String,
            billedPrice: String,
            price: Number,
            forcedOne: {
                type: Boolean,
                default: false
            },
        },

        watch: {
            value(to) {
                this.isToggled = to
            }
        },

        data() {
            return {
                canClick: true,
                isToggled: false
            }
        },

        mounted() {
            this.isToggled = this.value
            this.$parent.$on('close', (vm) => {
                if (vm != this)
                    this.isToggled = false
            })
        },

        methods: {

            toggleItem() {
                if (!this.canClick || (this.forcedOne && this.isToggled)) return
                this.canClick = false
                this.isToggled = !this.isToggled
                this.$emit('input', this.isToggled)
                setTimeout(() => { this.canClick = true }, 300)
                if(this.forcedOne)
                    this.$parent.$emit('close',this)
            }
        }
    }
</script>